import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { API_URL } from "../../actions/auth";
import axios from "axios";

import Sidebar from "../../components/Sidebar";

// TabPage.jsx

import ResultsMarksTeacher from "./ResultsMarksTeacher";
import ResultsAggrTeacher from "./ResultsAggrTeacher";

export default function TabPage() {

  const tabs = [
    { id: "results_aggr", label: "Results Aggregrate" },
    { id: "results_marks", label: "Results Marks" },
  ];

  const [activeTab, setActiveTab] = useState("results_aggr");
  const state = useSelector((state) => state);

  const renderNavTabs = () => {
    if (state.auth.user.is_class_teacher){
      return (
      <div className="flex justify-between mx-auto max-w-5xl rounded-lg bg-white shadow">
        {/* Tab navigation */}
        <div className="flex border-b border-gray-200">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-3 text-sm font-medium transition-colors
                ${
                  activeTab === tab.id
                    ? "border-b-2 border-blue-600 text-blue-600"
                    : "text-gray-500 hover:text-gray-800"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="pt-3 px-5">
          {state.auth.user.class_id} &nbsp;
          {state.auth.user.division}
        </div>
      </div>
     )
    }else{
      return (
      <div className="mx-auto max-w-5xl rounded-lg bg-white shadow">
      </div>
      )
    }
  }

  const renderContent = () => {
    
    if (state.auth.user.is_class_teacher){
        console.log('CT')
        switch (activeTab) {
          case "results_marks":
            return <ResultsMarksTeacher />;

          case "results_aggr":
            return <ResultsAggrTeacher />;

          default:
            return <ResultsMarksTeacher />;
        }
    }else{
        console.log('T')
        return <ResultsMarksTeacher />;
    }
  };


  return (

    <>
    <Sidebar />
    <div className="min-h-screen bg-gray-50 p-6 mt-12 ml-12">
        <div className="p-4">
          {renderNavTabs()}
        </div>

        {/* Conditional component rendering */}
        <div className="p-4">
          {renderContent()}
        </div>
    </div>
    </>
  );

}
